import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  overflow: "visible",
  preserveAspectRatio: "none",
  style: {"display":"block"},
  viewBox: "0 0 36 36"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "var(--stroke-0, white)",
      "stroke-opacity": ".2",
      d: "M18 35.5c9.665 0 17.5-7.835 17.5-17.5S27.665.5 18 .5.5 8.335.5 18 8.335 35.5 18 35.5Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "var(--fill-0, white)",
      "fill-opacity": ".5",
      d: "M14.48 15.049V24.5h-3.007v-9.451zm.192-2.918q.01.696-.46 1.163-.469.468-1.235.468h-.017q-.748 0-1.203-.468t-.456-1.163q0-.706.47-1.168.466-.463 1.223-.463t1.213.463.464 1.168M25.3 19.083V24.5h-3v-5.054q0-1.002-.368-1.57-.369-.567-1.153-.567-.574 0-.961.33-.389.328-.58.815-.1.285-.1.772V24.5H16.14q.018-3.806.018-6.17 0-2.365-.01-2.823l-.01-.458h3v1.373h-.018q.183-.305.374-.534.192-.228.515-.496.324-.267.793-.414.469-.148 1.044-.148 1.558 0 2.506 1.082t.948 3.171"
    }, null, -1)
  ]))]))
}
export default { render: render }